import { render, staticRenderFns } from "./Residencial.vue?vue&type=template&id=47c8af3b&"
import script from "./Residencial.vue?vue&type=script&lang=js&"
export * from "./Residencial.vue?vue&type=script&lang=js&"
import style0 from "./Residencial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports